import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Auth } from "../utils/Auth";

const PrivateRoutes = () => {
  const { authToken } = useContext(Auth);
  return authToken ? <Outlet /> : <Navigate to={"/"} />;
};
export default PrivateRoutes;
